import { Capacitor } from '@capacitor/core';
import { SITE_URL } from '../pages/public/publicPaths.js';

// Web: same-origin path so localhost opens the local /terms page.
// Native: absolute SITE_URL — the in-app browser has no app origin.
export function legalDocUrl(path, native = Capacitor.isNativePlatform()) {
    return native ? `${SITE_URL}${path}` : path;
}

// A plain <a target="_blank"> has nothing to open inside Capacitor's native
// webview — there is no tabbed browser chrome, so the click silently does
// nothing. This is why the privacy/terms links (and the store review link)
// worked in the dev-server/web checks but not in a real TestFlight build.
// @capacitor/browser opens an in-app SFSafariViewController / Custom Tab on
// native; on web it's a normal new-tab open. `url` must be absolute — the
// native browser has no notion of "this app's origin" to resolve a relative
// path against.
export async function openExternal(url) {
    if (Capacitor.isNativePlatform()) {
        const { Browser } = await import('@capacitor/browser');
        await Browser.open({ url });
    } else {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
